module.exports = __webpack_public_path__ + "img/placeholder.8cd07527.png";